/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlateformeDto } from './PlateformeDto';
import {
    PlateformeDtoFromJSON,
    PlateformeDtoFromJSONTyped,
    PlateformeDtoToJSON,
    PlateformeDtoToJSONTyped,
} from './PlateformeDto';

/**
 * 
 * @export
 * @interface GetPlateformeListResponse
 */
export interface GetPlateformeListResponse {
    /**
     * 
     * @type {Array<PlateformeDto>}
     * @memberof GetPlateformeListResponse
     */
    plateformes: Array<PlateformeDto>;
}

/**
 * Check if a given object implements the GetPlateformeListResponse interface.
 */
export function instanceOfGetPlateformeListResponse(value: object): value is GetPlateformeListResponse {
    if (!('plateformes' in value) || value['plateformes'] === undefined) return false;
    return true;
}

export function GetPlateformeListResponseFromJSON(json: any): GetPlateformeListResponse {
    return GetPlateformeListResponseFromJSONTyped(json, false);
}

export function GetPlateformeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlateformeListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'plateformes': ((json['plateformes'] as Array<any>).map(PlateformeDtoFromJSON)),
    };
}

export function GetPlateformeListResponseToJSON(json: any): GetPlateformeListResponse {
    return GetPlateformeListResponseToJSONTyped(json, false);
}

export function GetPlateformeListResponseToJSONTyped(value?: GetPlateformeListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plateformes': ((value['plateformes'] as Array<any>).map(PlateformeDtoToJSON)),
    };
}

